import { Outcome } from '../../../../@types';
import { useEventCardOutcomeCell } from '../../../../hooks/useEventCardOutcomeCell';
import EventCardOutcomeCellBase from '../../../molecules/EventCardOutcomeCellBase';

const makeStyles = (selected: boolean, disabled: boolean) => ({
  gridItem: {},
  container: {
    flex: 1,
    px: 1.25,
    py: 1.5,
    cursor: disabled ? 'not-allowed' : 'pointer',
    backgroundColor: selected ? 'neutral.100' : undefined,
    '&:hover': { backgroundColor: !selected && !disabled ? 'neutral.400' : undefined },
  },
  label: {
    color: selected ? 'neutral.600' : 'neutral.100',
    typography: 'body3',
  },
  odds: {
    color: disabled ? 'neutral.500' : selected ? 'primary.main' : 'secondary.main',
    typography: 'body3',
  },
});

type EventCardOutcomeCellProps = {
  outcome: Outcome;
  onClick: () => void;
  outcomeCount: number;
};

const EventCardOutcomeCell = ({ outcome, ...rest }: EventCardOutcomeCellProps) => {
  const { selected, disabled } = useEventCardOutcomeCell(outcome);
  const styles = makeStyles(selected, disabled);

  return <EventCardOutcomeCellBase {...rest} outcome={outcome} styles={styles} disabled={disabled} />;
};

export default EventCardOutcomeCell;
